import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';

const ResponseStatusFilter = ({
  selectedStatusesIds,
  navigateAction,
  paramKey,
}) => {
  const selectedCount = selectedStatusesIds.length;

  const handleSelect = useCallback(
    (statusId) =>
      navigateAction({
        [paramKey || 'surveyStatuses']: statusId
          ? xor(selectedStatusesIds, [statusId])
          : [],
      }),
    [selectedStatusesIds]
  );

  const renderMenuItem = useCallback(
    (status) => (
      <React.Fragment key={status.id}>
        <MenuItem
          active={selectedStatusesIds.includes(status.id)}
          eventKey={status.id.toString()}
          onSelect={handleSelect}
        >
          <span className={status.archived ? 'text-muted' : ''}>
            {status.name}
          </span>
        </MenuItem>
      </React.Fragment>
    ),
    [selectedStatusesIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Response Status</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="statuses-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {[
            { id: 'completed', name: 'Completed', archived: false },
            { id: 'pending', name: 'Pending', archived: false },
            { id: 'unsent', name: 'Unsent', archived: false },
          ].map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
};

ResponseStatusFilter.propTypes = {
  selectedStatusesIds: PropTypes.arrayOf(PropTypes.number),
};

ResponseStatusFilter.defaultProps = {
  selectedStatusesIds: [],
};

export default ResponseStatusFilter;
